export enum TENANT_JOIN_TYPES {
  closed = 'closed',
  open = 'open',
  restricted = 'restricted',
}
